import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const BufferToStringError = BaseErrorSchema.extend({
  errorType: z.literal('BufferToStringError'),
  errorReason: z.string(),
});

export type BufferToStringError = z.infer<typeof BufferToStringError>;
